import axios from 'axios'


const baseUrl = axios.create({ baseURL: "https://ecommer-muzawala.onrender.com" })

export default baseUrl